import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { type ReactElement } from 'react'
import { Button, IconButton, Typography } from 'shared/ui'
import { type IFlowAction } from 'widgets/Flow'
import styles from './styles.module.scss'

export type IFlowSelectedActionProps = {
  selectedActionStore: IFlowAction
  closeSelectedAction: () => void
  deleteAction: (action: IFlowAction) => void
  content: ReactElement | null
}

export const FlowSelectedAction = observer(
  ({
    selectedActionStore,
    closeSelectedAction,
    deleteAction,
    content,
  }: IFlowSelectedActionProps) => {
    if (!selectedActionStore) {
      return null
    }
    return (
      <div className={classNames(styles.selectedAction, 'nodrag nopan nowheel')}>
        <div className={styles.header}>
          <Typography variant={'body-xs-regular'} ariaLabel={'title'} className={styles.title}>
            {selectedActionStore.actionStore.name}
          </Typography>
          <IconButton
            icon={'close'}
            size={'small'}
            color={'secondary'}
            variant={'icon'}
            onClick={closeSelectedAction}
            ariaLabel='DefaultModal_close'
          />
        </div>
        <div className={styles.content}>{content}</div>
        <div className={styles.actions}>
          {/* <Button contained={'secondary'} size={'medium'} text={'Replace'} /> */}
          <Button
            contained={'secondary'}
            intent={'destructive'}
            size={'medium'}
            text={'Delete action'}
            onClick={() => deleteAction(selectedActionStore)}
          />
        </div>
      </div>
    )
  }
)
